<template>
  <div class="breadcrumb">
    <div class="back-option">
      <router-link :to="{ name: 'PaymentList'}">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </router-link>
    </div>
    <div class="dropdown">
      <div class="selected-text">Wallet</div>
    </div>
    <div class="action-button">
      <button :disabled="disableButton" :class="{ 'greyOut': disableButton }" class="btn btn-primary" @click="$emit('exportWallet')">Export</button>
      <DatePicker
        v-model="selectedMonth"
        @change="dateSelectTerm"
        type="month"
        :clearable="false"
        size="small"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    walletList: {
      type: [Array],
    },
  },
  data() {
    return {
      selectedMonth: new Date(),
    };
  },
  computed: {
    disableButton() {
      return (!this.walletList.length);
    },
  },
  methods: {
    dateSelectTerm(date) {
      const month = new Date(date).getMonth() + 1;
      const year = new Date(date).getFullYear();
      this.$emit('onChangeMonth', { month, year });
    },
  },
};
</script>
<style lang="scss" scoped>

  @import '~@common/styles-transporter/settings';
  .breadcrumb {
    border: 1px solid #cbd4d8;
    background: #fff;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    margin: 0 -20px 20px -20px;
    height: 50px;
    .back-option {
      width: 69px;
      vertical-align: middle;
      padding: 16px 10px;
      // background-color: #f2f1f1;
      text-align: center;
      border-right: 1px solid #cbd4d8;
      float: left;
    }
    .dropdown {
      color: #007fea;
      font-family:$fontSemibold;
      font-size: 1.4rem;
      letter-spacing: 1.17px;
      border-right: 1px solid #cbd4d8;
      display: inline-block;
      min-width: 200px;
      height: 50px;
      padding: 15px 20px;
      .selected-text{
        text-transform: uppercase;
      }
      .dropdown-selected {
        padding: 16px 20px;
      }
      .category {
        padding: 6px 20px;
        color: #007fea;
        padding-left: 10px;
        font-size: 1.4rem;
        text-transform: uppercase;
        margin-left: -3px;
        .selected-text {
          padding: 10px 20px;
        }
      }
    }
    .action-button {
      vertical-align: middle;
      padding: 9px 20px;
      text-align: center;
      border-right: 1px solid #cbd4d8;
      float: right;
      .btn-primary {
        border: 1px solid #008aff;
        padding: 7px 10px;
        color: #fff;
        border-radius: 5px;
        background-color: #008aff;
        outline: none;
        font-size: 1.2rem;
        cursor: pointer;
        text-transform: uppercase;
        margin: 0 10px;
        a {
          color: #fff;
          text-decoration: none;
        }
      }
    }
    .icon {
      transform: rotate(90deg);
    }
  }

</style>
